module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "subscribeMod"
  }, [_c('span', {
    staticClass: "noMob"
  }, [_vm._v("Subscribe")]), _vm._v(" "), _c('subscribe-module', {
    staticClass: "noMob"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu",
    class: _vm.searching ? 'is-searching' : ''
  }, [_vm._l((_vm.topBarButtons), function(button) {
    return _c('div', {
      key: button.id,
      staticClass: "nav-item nav-button"
    }, [(button.link.target !== '_blank') ? _c('router-link', {
      staticClass: "button",
      class: ("is-" + (button.style)),
      attrs: {
        "to": _vm.getPath(button.link.url)
      }
    }, [_c('span', [_vm._v(_vm._s(button.text))])]) : _c('a', {
      staticClass: "button",
      class: ("is-" + (button.style)),
      attrs: {
        "href": button.link.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('span', [_vm._v(_vm._s(button.text))])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-item newsletter"
  }, [_c('newsletter-module')], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item search"
  }, [_c('search-module')], 1)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f5d7eec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TopNav.vue
// module id = 765
// module chunks = 1